import "babel-polyfill";

// Themed bootstrap 4, requires manual build and checkin of generated css to avoid ejecting create-react-app
import './scss/bootstrap.css';
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactAI from 'react-appinsights';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import Config from "./common/Config";
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
export const history = createBrowserHistory({ basename: baseUrl });

// Add react statistics to application insights
ReactAI.init({instrumentationKey:'cddafc76-4de7-4291-a50c-3a8d34b715c6'}, history);
ReactAI.setAppContext({
    urlReferrer: document.referrer,
    uiVersion: Config.version
});

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  rootElement);

// Some issues with the service worker not being able to reload in production, deactivate for now
// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js